<div class="flex h-[90vh] w-[90vw] max-w-full flex-col overflow-hidden">
  <div class="flex items-center justify-between gap-2 p-2">
    <span class="truncate px-2 font-semibold">{{ data.fileName }}</span>
    <button mat-icon-button mat-dialog-close [attr.aria-label]="'Chiudi' | siaTranslate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="min-h-0 flex-1 overflow-auto px-2 pb-2">
    <sia-file-preview-handler
      [fileId]="data.fileId"
      [fileType]="data.fileType"
      [fileName]="data.fileName"
      [showFullscreen]="false"
      [showOcr]="true"
    ></sia-file-preview-handler>
  </div>
</div>
